import { render, staticRenderFns } from "./SingUp.vue?vue&type=template&id=b0d7f94e&"
import script from "./SingUp.vue?vue&type=script&lang=js&"
export * from "./SingUp.vue?vue&type=script&lang=js&"
import style0 from "./SingUp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports